import {
  DatePicker,
  DatePickerProps,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Calendar1Icon } from "./Icons";

interface GKDatePickerProps {
  inputLabel?: string;
  id?: string;
  name?: string;
  requiredField?: boolean;
  error?: boolean;
  helperText?: string;
}

const GKDatePicker = (props: GKDatePickerProps & DatePickerProps<any>) => {
  const { inputLabel, requiredField, slotProps } = props;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        {...props}
        label={inputLabel}
        slots={{
          ...props?.slots,
          openPickerIcon: Calendar1Icon,
        }}
        slotProps={{
          ...slotProps,
          openPickerIcon: {
            ...props?.slotProps?.openPickerIcon,
            fontSize: 20,
            color: "var(--neutral-500)",
          },
          textField: {
            ...props?.slotProps?.textField,
            required: requiredField,
            sx: {
              "& .MuiFormLabel-asterisk": {
                color: "red",
              },
              "& .MuiOutlinedInput-root, & .MuiInputBase-root": {
                borderRadius: "8px",
              },
              "& .MuiFormHelperText-root": {
                marginLeft: 0,
                marginRight: 0,
              },
            },
          },
        }}
        format="DD-MM-YYYY"
      />
    </LocalizationProvider>
  );
};

export default GKDatePicker;
